import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        children: [
            {
                path: '',
                name: 'main',
                component: () => import(/* webpackChunkName: "about" */ '../views/MainView.vue')
            },
            {
                path: '/regulatory_framework',
                name: 'regulatory_framework',
                component: () => import(/* webpackChunkName: "about" */ '../views/RegulatoryFramework.vue'),
                children: [
                    {
                        path: 'legislation',
                        name: 'legislation',
                        component: () => import('../components/regulatory.framework/legislation/LegislationView.vue'),
                    },
                    {
                        path: 'decrees',
                        name: 'decrees',
                        component: () => import('../components/regulatory.framework/decrees/DecreesView.vue')
                    },
                    {
                        path: 'resolution',
                        name: 'resolution',
                        component: () => import('../components/regulatory.framework/resolution/ResolutionView.vue')
                    },
                    {
                        path: 'gov-decrees',
                        name: 'gov-decrees',
                        component: () => import('../components/regulatory.framework/government.decrees/GovernmentDecreesView.vue')
                    },
                    {
                        path: 'regulatory-legal-acts',
                        name: 'regulatory-legal-acts',
                        component: () => import('../components/regulatory.framework/state.bodies/StateBodiesView.vue')
                    },
                    {
                        path: 'orders',
                        name: 'orders',
                        component: () => import('../components/regulatory.framework/orders/OrdersView.vue')
                    },
                    {
                        path: 'regulations',
                        name: 'regulations',
                        component: () => import('../components/regulatory.framework/regulations/RegulationsView.vue')
                    },
                ]
            },
            {
                path: '/corruption',
                component: () => import('../views/CorruptionView.vue'),
                children: [
                    {
                        path: '',
                        name: 'corruption',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 9 }
                    },
                    {
                        path: 'regulatory-legal',
                        name: 'regulatory-legal',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 16 }
                    },
                    {
                        path: 'methodical-recommendations',
                        name: 'methodical-recommendations',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 17 }
                    },
                    {
                        path: 'anti-corruption-doc-form',
                        name: 'anti-corruption-doc-form',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 18 }
                    },
                    {
                        path: 'corruption-report',
                        name: 'corruption-report',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 19 }
                    },
                    {
                        path: 'presantation',
                        name: 'presantation',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 20 }
                    },
                    {
                        path: 'feedback-reporting',
                        name: 'feedback-reporting',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 21 }
                    },
                    {
                        path: 'organizational-events',
                        name: 'organizational-events',
                        component: () => import('../components/activity/corruption/UniversalCorruptionList.vue'),
                        props: { typeId: 22 }
                    },
                ]
            },
            {
                path: '/activity',
                name: 'activity',
                component: () => import(/* webpackChunkName: "about" */ '../views/ActivityView.vue'),
                children: [
                    {
                        path: 'lease-of-state-property',
                        name: 'lease-of-state-property',
                        component: () => import('../components/activity/lease/LeaseOfStatePropertyView.vue')
                    },
                    {
                        path: 'property-relations',
                        name: 'property-relations',
                        component: () => import('../components/activity/relations/PropertyRelations.vue')
                    },
                    {
                        path: 'companies',
                        name: 'companies',
                        component: () => import('../components/activity/companyes/CompanyView.vue')
                    },
                    {
                        path: 'business-entities',
                        name: 'business-entities',
                        component: () => import('../components/activity/business.entities/BusinessEntities.vue')
                    },
                    {
                        path: 'accounting',
                        name: 'accounting',
                        component: () => import('../components/activity/accounting/AccountingOfStatePropertyView.vue')
                    },
                    {
                        path: 'court-proceedings',
                        name: 'court-proceedings',
                        component: () => import('../components/activity/court/CourtProceedingsView.vue')
                    },
                    {
                        path: 'investors',
                        name: 'investors',
                        component: () => import('../components/activity/investors/InvestorsView.vue')
                    },
                    {
                        path: 'purchases',
                        name: 'purchases',
                        component: () => import('../components/activity/purchases/PurchasesByState.vue')
                    },
                ]
            },
            {
                path: '/media',
                name: 'mediaView',
                component: () => import('../views/MediaView.vue'),
                children: [
                    {
                        path: 'news',
                        name: 'news',
                        component: () => import('../components/media/news/NewsView.vue')
                    },
                    {
                        path: 'competitions',
                        name: 'competitions',
                        component: () => import('../components/media/competitions/CompetitionsView.vue')
                    },
                    {
                        path: 'vacancies',
                        name: 'vacancies',
                        component: () => import('../components/media/vacancies/VacanciesView.vue')
                    },
                    {
                        path: 'government-procurement',
                        name: 'government-procurement',
                        component: () => import('../components/media/procurement/GovernmentProcurementView.vue')
                    },
                ]
            },
            {
                path: 'media/news/:id',
                name: 'newsDetails',
                component: () => import('../components/media/news/NewsDetails.vue'),
                props: true
            },
            {
                path: '/contacts',
                name: 'contacts',
                component: () => import(/* webpackChunkName: "about" */ '../views/ContactsView.vue'),
                children: [
                    {
                        path: 'phone-directory',
                        name: 'phone-directory',
                        component: () => import('../components/contacts/PhoneDirectory.vue')
                    },
                    {
                        path: 'public-reception',
                        name: 'public-reception',
                        component: () => import('../components/contacts/PublicReception.vue')
                    },
                    {
                        path: 'electronic-appeals',
                        name: 'electronic-appeals',
                        component: () => import('../components/contacts/ElectronicAppeals.vue')
                    },
                ]
            },
            {
                path: 'about/photo/:id',
                name: 'photoDetails',
                component: () => import('../components/about/photo/PhotoDetails.vue'),
                props: true
            },
            {
                path: '/about',
                name: 'about',
                component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
                children: [
                    {
                        path: 'position',
                        name: 'position',
                        component: () => import('../components/about/position/PositionView.vue')
                    },
                    {
                        path: 'management',
                        name: 'management',
                        component: () => import('../components/about/management/ManagementView.vue')
                    },
                    {
                        path: 'structure',
                        name: 'structure',
                        component: () => import('../components/about/structure/StructureView.vue')
                    },
                    {
                        path: 'photo',
                        name: 'photo',
                        component: () => import('../components/about/photo/PhotoView.vue')
                    },
                    {
                        path: 'video',
                        name: 'video',
                        component: () => import('../components/about/video/VideoView.vue')
                    },
                    {
                        path: 'media',
                        name: 'media',
                        component: () => import('../components/about/media/PublicationInMedia.vue'),

                    },
                    {
                        path: 'bank',
                        name: 'bank',
                        component: () => import('../components/about/bank/BankDetails.vue'),

                    },
                ]
            },

            {
                path: 'companies/:id',
                props: true,
                name: 'companyDetails',
                component: () => import('../components/activity/companyes/CompanyDetail.vue')
            },
            {
                path: 'media/:id',
                name: 'mediaDetail',
                component: () => import('../components/about/media/PublicationInMediaDetails.vue'),
                props: true
            },
            {
                path: 'video/:id',
                name: 'videoDetail',
                component: () => import('../components/about/video/VideoDetail.vue'),
                props: true
            },
            {
                path: 'article/:category/:id',
                name: 'articleDetail',
                component: () => import('../views/ArticleDetailView.vue'),
                props: true
            },
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
